import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import profileImg from "../../assets/images/svg/dashbordkv.svg"
import { useSelector } from "react-redux"
import Skeleton from "react-loading-skeleton"

const WelcomeComp = () => {
  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState('');
  const [profileimage, setprofileimage] = useState('')
  const [clientCode, setclientCode] = useState(null)
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      setname(obj.user.firstName);
      setemail(obj.user.email);
      setidx(obj.user.role);
      setprofileimage(obj.user.profileImg)
      if (obj.user.role === "CLIENT") {
        setclientCode(obj.user.clientCode)
      }
      setTimeout(() => {

      }, 3000);
    }
  }, []);
  const { roles, loader } = useSelector(state => ({
    roles: state.GetAdminRoles.roles,
    loader: state.GetAdminRoles.loader
  })) 
  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft welcome-card">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome Back !</h5>
                <p>Glottis Logistics Dashboard</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="Welcome" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0 pb-0 profile-info">
          <div className="">
            <div className="avatar-md-lg profile-user-wid ">
              {profileimage ?
                <img
                  src={profileimage}
                  alt=""
                  className="img-thumbnail rounded-circle h-100 w-100"
                /> :
                <div className="avatar-md-lg mx-auto">
                  <span
                    className={
                      "avatar-title rounded-circle bg-soft bg-"
                    }
                  >
                    {name.charAt(0).toUpperCase()}
                  </span>
                </div>
              }
            </div>
          </div>
          <div className="ps-2 content">
            {loader ? <Skeleton height={"18px"} width={'80px'} /> :
              <h5 className="font-size-15 fw-bold text-capitalize mb-0">{name.toLowerCase()}</h5>}
            {loader ? <Skeleton height={"18px"} width={'80px'} /> :
              <p className="text-muted mb-0 text-truncate text-capitalize">
                {
                  clientCode !== null ? clientCode : roles?.map((role) => (
                    (idx === role.value) && role.label.toLowerCase()
                  ))
                }
              </p>}
          </div>
          <div className="w-100 content pe-0">
            <div className="text-end">
              <Link
                to="/profile"
                className="btn secountry-btn  btn-sm"
              >
                View Profile
              </Link>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp